
define('text!templates/modules/dashboard/graph/graph-content.html',[],function () { return '<div class="select-graph-series"></div>\n<div class="chart"></div>\n';});

